
import React, { useState } from "react";
import { 
    TextField, Button, Typography, Card, Grid, Box, Link, FormLabel, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import * as CONSTANTS from '../../constants'

import {
    request_reset_password,
} from '../../services/login_system'


export default function ResetPasswordForm({lang, onClose, setLoginMode }) {

    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState('');

    let isValidInput = false;

    const switchToLoginMode = () => {
        setLoginMode('Login');
    }

    const handleSubmit = async (e) => {

        e.preventDefault();
        if (!isValidInput) return;

        const [status, result] = await request_reset_password(email);

        // success reset
        if (status === 200) {

            onClose();
        } else {
            setEmailError(true);
            setEmailErrorMessage("Oops, something went wrong. Please try again later.");
        }

    }
	

	const validateInputs = () => {

        const user_email = document.getElementById('email');
        let isValid = true;

        if (!user_email.value || !/\S+@\S+\.\S+/.test(user_email.value)) {
            setEmailError(true);
            setEmailErrorMessage(CONSTANTS.LOGIN_FORM.ERROR_MESSAGE.ENTER_VALID_EMAIL[lang]);
            isValid = false;
        } else {
            setEmailError(false);
            setEmailErrorMessage('');
        }
        
        setEmail(user_email.value)
        
        isValidInput = isValid;

        return isValid;
    };


	return (
		<Card
            sx={{
                width: '25vw',
                padding: '3vw',
                minWidth: "300px",
            }}
        >
            <div>
                <Typography
                    component="h1"
                    variant="h4"
                    fontWeight='bold'
                    sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
                    mb={3}
                >
                    {CONSTANTS.RESET_PASSWORD_FORM.FORGOT_PASSWORD[lang]}
                </Typography>
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 1,
                        top: 1,
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            </div>
            <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    gap: 2,
                }}
            >
                <FormLabel htmlFor="email">{CONSTANTS.LOGIN_FORM.EMAIL[lang]}</FormLabel>
                <TextField
                    error={emailError}
                    helperText={emailErrorMessage}
                    id="email"
                    type="email"
                    name="email"
                    placeholder="your@email.com"
                    autoComplete="email"
                    autoFocus
                    required
                    fullWidth
                    variant="outlined"
                    color={emailError ? 'error' : 'primary'}
                    sx={{ ariaLabel: 'email' }}
                />

                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={() => validateInputs()}
                >
                    {CONSTANTS.RESET_PASSWORD_FORM.SEND_EMAIL[lang]}
                </Button>
                <Grid container>
                    <Link 
                        component="button"
                        onClick={() => switchToLoginMode()}
                        variant="body2"
                        sx={{ alignSelf: 'baseline' }}
                    >
                        {CONSTANTS.RESET_PASSWORD_FORM.BACK_TO_LOGIN[lang]}
                    </Link>
                </Grid>
            </Box>
		</Card>
	);
}
